import { render, staticRenderFns } from "./CampaignEvent.vue?vue&type=template&id=fa73a3a0&scoped=true"
import script from "./CampaignEvent.vue?vue&type=script&lang=js"
export * from "./CampaignEvent.vue?vue&type=script&lang=js"
import style0 from "./CampaignEvent.vue?vue&type=style&index=0&id=fa73a3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa73a3a0",
  null
  
)

export default component.exports